module.exports = __webpack_public_path__ + "static/media/Children.a4a4f665.png";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/onboardig/Children.png
// module id = 3831
// module chunks = 0